$(document).on('click', '.js-trigger-product-btn', function (event) {
  event.preventDefault();

  $(this).closest('.boost-pfs-filter-product-item-inner').find('.boost-pfs-addtocart-btn').trigger('click');
});
